App.directive('paginationBox', ['$window', 'Config', function ($window, Config) {
    return {
    	restrict: 'AEC',
        scope: {
            pageChanged: '&',
        	count: '=',
            current: '=',
            max: '@'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/pagination.html',
        link: function(scope, element, attrs) {
            scope.range = function(count) {
                return new Array(count);
            }
        }
    };
}]);